import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import usePageMeta from "../hooks/usePageMeta";
import { http } from "../lib/api";

const CARTOON_1 = "https://customer-assets.emergentagent.com/job_trance-bookings/artifacts/n3gj63gu_WhatsApp%20Image%202026-06-15%20at%2023.10.29.jpeg";
const CARTOON_2 = "https://customer-assets.emergentagent.com/job_trance-bookings/artifacts/quisz5he_WhatsApp%20Image%202026-06-15%20at%2023.10.29%20%282%29.jpeg";

// Light cartoons sprinkled across the list for visual rhythm
const CARTOON_SLOTS = { 2: { src: CARTOON_1, alt: "Pocket-watch induction cartoon" }, 7: { src: CARTOON_2, alt: "Hypnosis cartoon" } };

function formatDate(iso) {
  if (!iso) return "";
  const m = iso.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return iso;
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  return `${months[parseInt(m[2], 10) - 1]} ${parseInt(m[3], 10)}, ${m[1]}`;
}

function excerpt(md) {
  if (!md) return "";
  // Strip markdown emphasis/links for the card excerpt
  const plain = md
    .replace(/\[([^\]]+)\]\([^)]+\)/g, "$1")
    .replace(/\*\*([^*]+)\*\*/g, "$1")
    .replace(/\*([^*]+)\*/g, "$1")
    .replace(/\n+/g, " ")
    .trim();
  return plain.length > 220 ? plain.slice(0, 220).trimEnd() + "…" : plain;
}

export default function Blog() {
  usePageMeta({
    title: "The Journal - Erotic Hypnosis Writings",
    description: "Essays, case notes and musings on erotic hypnosis, trance work, consent and the practice - from London-based hypnotist Queen Cleopatra.",
    path: "/blog",
  });

  const [posts, setPosts] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    http.get("/blog").then((r) => setPosts(r.data.items || [])).catch((e) => setErr(e.message || "Failed to load"));
  }, []);

  return (
    <div data-testid="page-blog">
      <section className="py-24 md:py-32 max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <div className="eyebrow mb-5">The Journal</div>
        <h1 className="font-serif text-5xl md:text-7xl text-cream leading-[1] max-w-3xl">
          Notes from the <em className="text-gold">candlelit room</em>.
        </h1>
        <p className="mt-6 text-cream/65 max-w-2xl leading-relaxed">
          A collection of writings from across the years - some freshly penned, many rescued from
          the archive, all restored to their proper home.
        </p>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 pb-32">
        {err && <p className="text-cream/60">Could not load posts. {err}</p>}
        {!posts && !err && <p className="text-cream/40 text-sm">Loading…</p>}
        {posts && posts.length === 0 && <p className="text-cream/60">No posts yet.</p>}
        {posts && posts.length > 0 && (
          <div className="grid md:grid-cols-2 gap-px bg-[#c9a04b]/15">
            {posts.map((p, i) => {
              const cartoon = CARTOON_SLOTS[i];
              return (
                <article key={p.slug} data-testid={`blog-${p.slug}`} className="bg-charcoal p-8 md:p-10 flex flex-col min-h-[260px]">
                  <div className="eyebrow mb-3 text-cream/50">
                    {p.category || "The Journal"}
                    {p.date && <> · {formatDate(p.date)}</>}
                  </div>
                  <h2 className="font-serif text-2xl md:text-3xl text-cream leading-tight mb-4">
                    <Link to={`/blog/${p.slug}`} className="hover:text-gold transition">{p.title}</Link>
                  </h2>
                  <p className="text-cream/65 leading-relaxed mb-6 flex-1">{excerpt(p.body_md)}</p>
                  {cartoon && (
                    <div className="mb-6 bg-cream border border-[#c9a04b]/25 p-2">
                      <img src={cartoon.src} alt={cartoon.alt} loading="lazy" className="w-full h-auto" />
                    </div>
                  )}
                  <Link to={`/blog/${p.slug}`} className="link-gold text-xs uppercase tracking-[0.22em]">
                    Read the entry →
                  </Link>
                </article>
              );
            })}
          </div>
        )}
      </section>
    </div>
  );
}
